/* src/app/modules/coils/components/coil-phone-view/coil-phone-view.component.scss */
:host {
  background-color: white;
  height: 100%;
  padding: inherit;
}
.coil-name-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.date-container {
  display: flex;
  align-items: center;
  margin-block-start: -1rem;
}
.dayOfWeek {
  margin-inline-start: 0.5rem;
  color: #000;
}
.date-font {
  display: flex;
  align-items: center;
  color: #000;
  font-size: 1.37rem;
  font-weight: 600;
}
.coil-name {
  color: #000;
  font-size: 13px;
  font-style: normal;
}
.date-icon {
  color: white;
  border-radius: 60%;
  height: 1.9rem;
  width: 1.9rem;
}
.status-icon {
  color: white;
  border-radius: 60%;
  height: 1rem;
  width: 1rem;
}
.table-container {
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.table-title,
.table-coil-element {
  position: relative;
}
.table-title::after,
.table-coil-element::after {
  content: "";
  display: block;
  width: 500rem;
  border-bottom: 1px solid #d3d3d3;
  position: absolute;
  bottom: 0rem;
  left: -50rem;
}
.table-title {
  display: flex;
  gap: 6rem;
  padding-block-end: 0.5rem;
}
.table-title::after {
  content: "";
  display: block;
  width: 500rem;
  border-bottom: 2px solid #d3d3d3;
  position: absolute;
  bottom: -0.5rem;
  left: -50rem;
}
.table-coil-element {
  left: 2rem;
}
.table-icon {
  position: relative;
  left: -2.2rem;
}
tbody tr:last-child .table-coil-element::after {
  content: none;
}
.local-coil {
  color: var(--text-primary);
}
.dates {
  color: rgba(0, 0, 0, 0.6);
}
.date-range-container {
  background: #ebebeb;
  width: 100vw;
  margin-inline-start: -1rem;
  margin-block-start: -1rem;
  padding-block-end: 1rem;
}
.dot-icon {
  padding: 16px 0 12px 0;
}
/*# sourceMappingURL=coil-phone-view.component.css.map */
